export default function heroLine(gsap) {
    const currentWidth = window.innerWidth;
    window.addEventListener("resize", () => {
        let resizeScreenSize = window.innerWidth;

        if (resizeScreenSize !== currentWidth) {
            timeline();
        } else {
            return;
        }
    });

    function timeline(reset = true) {
        let mediaQueryList = window.matchMedia("(min-width: 980px)").matches;
        let hero = document.querySelector(".hero");
        let heroContent = hero?.querySelector(".hero-content");
        let line = hero?.querySelector(".hero-content .line");
        if (!line) return;

        if (line.classList.contains("hero-left") || line.classList.contains("hero-right")) {
            if (line.classList.contains("hero-span")) {
                let offsetLeft =
                    heroContent.parentElement.offsetLeft + heroContent.querySelector("h1 span").scrollWidth;
                line?.style.setProperty("--offset-left", `-${heroContent.parentElement.offsetLeft}px`);
                line?.style.setProperty("--offset-width", `${offsetLeft}px`);
                //console.log("hero-span");
            } else {
                let offsetLeft = mediaQueryList
                    ? heroContent.parentElement.offsetLeft + heroContent.querySelector("h1").scrollWidth
                    : heroContent.parentElement.offsetLeft + heroContent.querySelector("h1 span").scrollWidth;
                line?.style.setProperty("--offset-left", `-${heroContent.parentElement.offsetLeft}px`);
                line?.style.setProperty("--offset-width", `${offsetLeft}px`);
            }
        } else {
            let offsetLeft = heroContent.offsetLeft + heroContent.parentElement.offsetLeft;
            line?.style.setProperty("--offset-left", `-${offsetLeft}px`);
            line?.style.setProperty("--offset-width", `${offsetLeft}px`);
        }

        //console.log(heroContent.parentElement.offsetLeft);
        //console.log(heroContent.querySelector("h1 span").scrollWidth);
        line?.style.setProperty("--screen-size", `${currentWidth}px`);

        let yPosition = mediaQueryList ? 95 : 55;
        let xPosition = line.classList.contains("hero-left") ? "-100%" : "100%";

        let tl = gsap.timeline({ paused: true });
        if (line.classList.contains("hero-icon")) {
            if (reset) {
                tl.set(line, { x: "-100%", y: `${yPosition}px` });
            } else {
                tl.set(line, { y: `${yPosition}px` });
            }
        } else {
            if (reset) {
                tl.set(line, { x: xPosition });
            }
        }

        tl.to(line, { x: 0, duration: 1, ease: "expo.in" });

        if (line) tl.resume();
    }

    timeline(false);
}
